import type { CurrentUser } from 'stores/useUserStore';

import { storageManager, StorageType } from 'utils/storageUtils';

type StoredData = {
  actualUser: CurrentUser;
  impersonatedUserId: string;
};

export const impersonationStorage = storageManager.createOrFetchStorage<StoredData>('impersonation', StorageType.LOCAL);
